import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';

export default function EditActivity() {
    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const navigate = useNavigate()
    const { activityId } = useParams()

    const handleSubmit = async (event, id) => {
        event.preventDefault();
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(
                `https://fitnesstrac-kr.herokuapp.com/api/activities/${activityId}`,
                {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        name: name,
                        description: description
                    }),
                }
            );
            const result = await response.json();
            console.log(result)
            navigate("/Activities");
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="form-container" >
            <form onSubmit={handleSubmit}>
                <h1>Edit an Activity</h1>
                <div>
                    <label htmlFor="name"></label>
                    <input
                        type="text"
                        id="name"
                        placeholder="Activity Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                <div>
                    <label htmlFor="description"></label>
                    <input
                        type="text"
                        id="description"
                        placeholder="Activity Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>
                <button className="submit-btn" type="submit">Edit Activity</button>
            </form>
        </div>
    );
}
